<template lang="pug">
  .course-report-wrap
    .course-report-grid

      .course(v-for='programCourse in programCourseList'
              :key='programCourse.id'
              @click='onOpenDetail(programCourse)'
              :class='{ active: selectedProgramCourse && programCourse.id === selectedProgramCourse.id }'
      )
        .course-title {{ programCourse.course.title }}
        .course-status
          icon(v-if='programCourse.failed' name='times-circle' color='darkred' :scale='1.3')
          icon(v-if='programCourse.passed' name='check-circle' color='green' :scale='1.3')
          icon(v-if='programCourse.inProgress' name='clock' color='orange' :scale='1.3')
          icon(v-if='programCourse.pending' name='minus' color='#ddd' :scale='1.3')

    .course-details(v-if='selectedProgramCourse && selectedProgramCourseAttempt')
      .course-title {{ selectedProgramCourse.course.title }}
      p(v-if='selectedProgramCourse.failed || selectedProgramCourse.passed') Completed: {{ formattedDate(selectedProgramCourseAttempt.updatedAt) }}
      p Time: {{ selectedProgramCourseAttempt.sessionTime }}
      p Attempts: {{ selectedProgramCourse.attemptsCount }}
      .status
        template(v-if='selectedProgramCourse.passed' )
          icon(name='check-circle' color='green' :scale='1.3')
          p {{ selectedProgramCourseAttempt.score }}% PASS

        template(v-if='selectedProgramCourse.failed' )
          icon(v-if='selectedProgramCourse.failed' name='times-circle' color='darkred' :scale='1.3')
          p {{ selectedProgramCourseAttempt.score }}% FAIL

        icon(v-if='selectedProgramCourse.inProgress' name='clock' color='orange' :scale='1.3')
        icon(v-if='selectedProgramCourse.pending' name='minus' color='#ddd' :scale='1.3')

      el-button(type="primary" @click='onReassign') RE-ASSIGN

</template>

<script>
import format from "date-fns/format";

export default {
  props: [
    "programCourseList",
    "selectedProgramCourse",
    "selectedProgramCourseAttempt"
  ],
  methods: {
    formattedDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    onOpenDetail(programCourse) {
      this.$emit("open-detail", programCourse);
    },
    onReassign() {
      this.$emit("reassign", this.selectedProgramCourse);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/_mixins.scss";

.course-report-wrap {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  align-items: flex-start;
  background: white;
}

.course-report-grid {
  padding: 20px;
  width: 70%;
  display: flex;
  flex-wrap: wrap;

  .course {
    width: calc(100% / 5 - 5px);
    display: flex;
    flex-direction: column;
    margin: 5px;
    cursor: pointer;
    &.active {
      .course-title {
        background: #8b8b8b;
      }
      .course-status {
        background: #e7e7e7;
        border: none;
      }
    }
    .course-title {
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      @include heading_font();
      height: 100px;
      background: #afafaf;
    }
    .course-status {
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e7e7e7;
    }
  }
}

.course-details {
  border-left: 2px solid #f4f5f7;

  padding: 20px;
  align-self: stretch;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  .course-title {
    @include heading_font($fs: 17px);
    margin: 0 0 10px 0;
  }
  p {
    margin: 0 0 10px 0;
  }
  .status {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 40px;
    .fa-icon {
      margin: 0 10px 0 0;
    }
    p {
      margin: 0;
    }
  }
}
</style>
